export default __webpack_public_path__ + "static/media/spaced_rep_bg.a17803bc.png";